import { useEffect, useState } from 'react';
import { Flex } from 'antd';
import { X } from 'lucide-react';
import useNavigateApi from '../../appRoute/useNavigateApi';
import MyLucideIcon from '../../components/myIcon/MyLucideIcon';
import MyButtonSuccess from '../../components/myButton/MyButtonSuccess';

const TrialNotifRow = ({ title, btnLabel, path }) => {
  const navigateApi = useNavigateApi();

  const [trialClose, setTrialClose] = useState(false);

  useEffect(() => {
    setTrialClose(false);
  }, []);

  if (trialClose) return null;
  return (
    <Flex
      id="trial_notif_header"
      className="orange_notification_wrapper no-print"
      align="center"
      justify="center"
      gap={20}
    >
      <div>{title}</div>
      <MyButtonSuccess label={btnLabel} onClick={() => navigateApi(path)} />
      <MyLucideIcon
        icon={X}
        className="link_cursor"
        style={{ position: 'absolute', right: 20 }}
        onClick={() => {
          setTrialClose(true);
        }}
      />
    </Flex>
  );
};

export default TrialNotifRow;
